export default __webpack_public_path__ + "static/media/mapa.11f64ec5.jpg";